import AdminHeader from "../../component/AdminHeader";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useEffect, useState } from "react";

const dashboardListEndpoint = ApiEndpoints.Dashboard.List;
const MonthlyEndpoint = ApiEndpoints.Dashboard.monthlycount;

export default function Dashboard() {
    const [leadsCount, setLeadsCount] = useState();
    const [tempCount, setTempCount] = useState();
    const [selectedMonth, setSelectedMonth] = useState({
        ar_denial_bottom_form_count: "",
        ar_denial_top_form_count: "",
        blog_count: "",
        blog_form_count: "",
        casestudy_count: "",
        casestudy_form_count: "",
        complex_form_count: "",
        contact_count: "",
        contact_form_count: "",
        infographic_form_count: "",
        jobapplication_count: "",
        leadership_form_count: "",
        newsletter_count: "",
        newsletter_form_count: "",
        pressrelease_count: "",
        provider_form_count: "",
        query_form_count: "",
        revenue_integrity_top_form_count: "",
        riskGeni_top_form_count: "",
        seo_count: "",
        solution_form_count: "",
    });

    const getLeadsCount = async () => {
        try {
            const response = await ApiRequest("GET", dashboardListEndpoint);
            setLeadsCount(response);
            setTempCount(response);
        } catch (error) {
            console.error("Error fetching leads count:", error);
        }
    }

    useEffect(() => {
        getLeadsCount();
    }, []);


    // monthly 
    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (value !== "") {
            setSelectedMonth((prev) => ({
                ...prev,
                [name]: value,
            }));
            try {
                const response = await ApiRequest("GET", `${MonthlyEndpoint}/${value}`);
                setLeadsCount((prev) => ({
                    ...prev,
                    [name]: response[name],
                }));
            } catch (error) {
                console.error("Error fetching leads count:", error);
            }
        } else {
            setLeadsCount((prev) => ({
                ...prev,
                [name]: tempCount[name],
            }));
            setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
        }
    };
     const handleRefresh = async (name) => {
        setLeadsCount((prev) => ({
            ...prev,
            [name]: tempCount[name],
        }));

        setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
    };


 const year = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const options = [
        { value: year + "-01", title: "January" },
        { value: year + "-02", title: "February" },
        { value: year + "-03", title: "March" },
        { value: year + "-04", title: "April" },
        { value: year + "-05", title: "May" },
        { value: year + "-06", title: "June" },
        { value: year + "-07", title: "July" },
        { value: year + "-08", title: "August" },
        { value: year + "-09", title: "September" },
        { value: year + "-10", title: "October" },
        { value: year + "-11", title: "November" },
        { value: year + "-12", title: "December" }
    ];

    const dropData = options.filter((item) => {
        const month = item.value.split("-").map(Number)[1];
        return month <= currentMonth;
    });


    const pagename = {
        name: 'Dashboard',
        user: 'Admin',
        innerpage: 'Dashboard'
    }


    return (
        <>
            <AdminHeader pagename={pagename} />
            <div className="add-btn-section">
                <div className="row">
                    <div class="col-lg-4">
                        <div class="home-dashbox limeGreen-card">
                            <div class="dashbox-month">
                                <span>Total Blogs</span>
                                <div>
                                    <select
                                        value={selectedMonth.blog_count}
                                        onChange={handleChange}
                                        name="blog_count" >
                                       <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("blog_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.blog_count}</h4>
                            <div class="dashbox-link">
                                <p>Blogs</p>
                                <Link to="blog">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox pink-card">
                            <div class="dashbox-month">
                                <span>Total Blog Form</span>
                                <div>
                                    <select
                                        value={selectedMonth.blog_form_count}
                                        onChange={handleChange}
                                        name="blog_form_count" >
                                        <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("blog_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.blog_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Blog Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox gradient-card">
                            <div class="dashbox-month">
                                <span>Total Seo Count</span>
                                <div>
                                    <select value={selectedMonth.seo_count} onChange={handleChange} name="seo_count"  >
                                     <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("seo_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.seo_count}</h4>
                            <div class="dashbox-link">
                                <p> Seo  </p>
                                <Link to="seo">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox orange-card">
                            <div class="dashbox-month">
                                <span>Total Case Study</span>
                                <div>
                                    <select
                                        value={selectedMonth.casestudy_count}
                                        onChange={handleChange}
                                        name="casestudy_count"   >
                                     <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("casestudy_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.casestudy_count}</h4>
                            <div class="dashbox-link">
                                <p>Case Study </p>
                                <Link to="case">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="home-dashbox lavender-color">
                            <div class="dashbox-month">
                                <span>Total Casestudy Form </span>
                                <div>
                                    <select
                                        value={selectedMonth.casestudy_form_count}
                                        onChange={handleChange}
                                        name="casestudy_form_count"   >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("casestudy_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.casestudy_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Casestudy Form</p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox purple-card">
                            <div class="dashbox-month">
                                <span>Total Complex Form</span>
                                <div>
                                    <select
                                        value={selectedMonth.complex_form_count}
                                        onChange={handleChange}
                                        name="complex_form_count"   >
                                       <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("complex_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.complex_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Complex Form</p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox green-card">
                            <div class="dashbox-month">
                                <span>Total Contact</span>
                                <div>
                                    <select
                                        value={selectedMonth.contact_count}
                                        onChange={handleChange}
                                        name="contact_count"   >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("contact_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.contact_count}</h4>
                            <div class="dashbox-link">
                                <p>Contact </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox gradient-card">
                            <div class="dashbox-month">
                                <span>Total Contact Form </span>
                                <div>
                                    <select value={selectedMonth.contact_form_count} onChange={handleChange} name="contact_form_count"  >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("contact_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.contact_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Contact Form  </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>



                    {/* <div class="col-lg-4">
                        <div class="home-dashbox orange-card">
                            <div class="dashbox-month">
                                <span>Total Newsletters </span>
                                <div>
                                    <select
                                        value={selectedMonth.newsletter_count}
                                        onChange={handleChange}
                                        name="newsletter_count"    >
                                        <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("newsletter_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.newsletter_count}</h4>
                            <div class="dashbox-link">
                                <p>Newsletters </p>
                                <Link to="newsletter-page">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div> */}



                    <div class="col-lg-4">
                        <div class="home-dashbox gradient-card">
                            <div class="dashbox-month">
                                <span>Total Infographic Form </span>
                                <div>
                                    <select value={selectedMonth.infographic_form_count} onChange={handleChange} name="infographic_form_count"  >
                                       <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("infographic_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.infographic_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Infographic Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="home-dashbox mediumBlue-card">
                            <div class="dashbox-month">
                                <span>Total Job Applications </span>
                                <div>
                                    <select value={selectedMonth.jobapplication_count} onChange={handleChange} name="jobapplication_count"  >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("jobapplication_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.jobapplication_count}</h4>
                            <div class="dashbox-link">
                                <p>Job Applications </p>
                                <Link to="job-applications">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>



                    <div class="col-lg-4">
                        <div class="home-dashbox chocolate-card">
                            <div class="dashbox-month">
                                <span>Total Leardership Form </span>
                                <div>
                                    <select value={selectedMonth.leadership_form_count} onChange={handleChange} name="leadership_form_count"  >
                                       <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("leadership_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.leadership_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Leardership </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox darkSlateGray-card">
                            <div class="dashbox-month">
                                <span>Total Newsletter </span>
                                <div>
                                    <select value={selectedMonth.newsletter_count} onChange={handleChange} name="newsletter_count"  >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("newsletter_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.newsletter_count}</h4>
                            <div class="dashbox-link">
                                <p>Newsletter </p>
                                <Link to="newsletter-page">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>



                    <div class="col-lg-4">
                        <div class="home-dashbox rosyBrown-card">
                            <div class="dashbox-month">
                                <span>Total Newsletter Form </span>
                                <div>
                                    <select value={selectedMonth.newsletter_form_count} onChange={handleChange} name="newsletter_form_count"  >
                                    <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("newsletter_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.newsletter_form_count}</h4>
                            <div class="dashbox-link">
                                <p>Newsletter Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox steelBlue-card">
                            <div class="dashbox-month">
                                <span>Total Press Release </span>
                                <div>
                                    <select value={selectedMonth.pressrelease_count} onChange={handleChange} name="pressrelease_count"  >
                                    <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("pressrelease_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.pressrelease_count}</h4>
                            <div class="dashbox-link">
                                <p>Press Release </p>
                                <Link to="press-release">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>



                    <div class="col-lg-4">
                        <div class="home-dashbox mediumAquamarine-card">
                            <div class="dashbox-month">
                                <span>Total Provider Form </span>
                                <div>
                                    <select value={selectedMonth.provider_form_count} onChange={handleChange} name="provider_form_count"  >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("provider_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.provider_form_count}</h4>
                            <div class="dashbox-link">
                                <p> Provider Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox limeGreen-card">
                            <div class="dashbox-month">
                                <span>Total Query Form </span>
                                <div>
                                    <select value={selectedMonth.query_form_count} onChange={handleChange} name="query_form_count"  >
                                       <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("query_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.query_form_count}</h4>
                            <div class="dashbox-link">
                                <p> Query Form  </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox lavender-color">
                            <div class="dashbox-month">
                                <span>Total Revenue  Form</span>
                                <div>
                                    <select value={selectedMonth.revenue_integrity_top_form_count} onChange={handleChange} name="revenue_integrity_top_form_count"  >
                                     <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("revenue_integrity_top_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.revenue_integrity_top_form_count}</h4>
                            <div class="dashbox-link">
                                <p> Revenue  Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>


                    <div class="col-lg-4">
                        <div class="home-dashbox deep-pink">
                            <div class="dashbox-month">
                                <span>Total RiskGen-i Form</span>
                                <div>
                                    <select value={selectedMonth.riskGeni_top_form_count} onChange={handleChange} name="riskGeni_top_form_count"  >
                                      <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("riskGeni_top_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.riskGeni_top_form_count}</h4>
                            <div class="dashbox-link">
                                <p> Revenue Integrity Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>



                    <div class="col-lg-4">
                        <div class="home-dashbox dark-khaki">
                            <div class="dashbox-month">
                                <span>Total Solution Form</span>
                                <div>
                                    <select value={selectedMonth.solution_form_count} onChange={handleChange} name="solution_form_count"  >
                                     <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("solution_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.solution_form_count}</h4>
                            <div class="dashbox-link">
                                <p>  Solution Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="home-dashbox maroom-color">
                            <div class="dashbox-month">
                                <span>Total  Denial Top Form </span>
                                <div>
                                    <select value={selectedMonth.ar_denial_top_form_count} onChange={handleChange} name="ar_denial_top_form_count"  >
                                     <option value="">All Months</option>
                                        {dropData.map((drop, index) => (
                                            <option key={index} value={drop.value}>{drop.title}</option>
                                        ))}
                                    </select>
                                    <a onClick={() => handleRefresh("ar_denial_top_form_count")}><Icons name="rotateRight" /></a>
                                </div>
                            </div>
                            <h4>{leadsCount?.ar_denial_top_form_count}</h4>
                            <div class="dashbox-link">
                                <p>  Denial Top Form </p>
                                <Link to="contact">See Full List</Link>
                            </div>
                            <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )
}
